export default __webpack_public_path__ + "static/media/assessment-icon.933063bd.svg";